module.exports = __webpack_public_path__ + "images/emoji/heavy_plus_sign.b4e8d59d3b3c805e2351.png";